import {
  HttpErrorResponse,
  HttpInterceptorFn,
} from '@angular/common/http';
import { inject, Injector } from '@angular/core';
import { Router } from '@angular/router';
import { catchError, throwError } from 'rxjs';
import { environment } from '../../environments/environment';
import { AccountAuthService } from './account-auth.service';

const INVALID_SESSION_CODES = new Set([
  'INVALID_JWT',
  'AUTHENTICATION_REQUIRED',
]);

function isInvalidSessionError(
  reqUrl: string,
  error: HttpErrorResponse
): boolean {
  const isKnownApi =
    reqUrl.startsWith(environment.encryptionApiUrl) ||
    reqUrl.startsWith(environment.apiUrl);
  if (!isKnownApi) {
    return false;
  }
  if (error.status !== 401) {
    return false;
  }

  const code = error.error?.code;
  // Login/password failures use other codes (e.g. INVALID_CREDENTIALS) and must not redirect.
  return typeof code === 'string' && INVALID_SESSION_CODES.has(code);
}

/**
 * Clears the local account session and sends the user to login when the API
 * reports an invalid/missing login JWT. The API also clears the httpOnly cookie.
 */
export const authInvalidJwtInterceptor: HttpInterceptorFn = (req, next) => {
  const injector = inject(Injector);
  const router = inject(Router);

  return next(req).pipe(
    catchError((error: unknown) => {
      if (
        error instanceof HttpErrorResponse &&
        isInvalidSessionError(req.url, error)
      ) {
        const auth = injector.get(AccountAuthService);
        auth.clearSession();
        if (!router.url.startsWith('/login')) {
          void router.navigateByUrl('/login');
        }
      }
      return throwError(() => error);
    })
  );
};
